<mat-form-field class="history-keyword-form-field" appearance="outline">
  <mat-label>分野・単元・出題テーマをキーワード検索（複数可）</mat-label>
  <input matInput [formControl]="keywordFormControl" />
</mat-form-field>
